'use strict';

const events = require('dom-events');
const Cookies = require('js-cookie');

const utils = require('../utils.js');

function AnnouncementPopup (ref) {
  this.cls = {
    invisible: 'invisible'
  };

  this.refs = {
    announcement: '[data-ref="announcement-' + ref + '"]',
    action: '[data-ref="announcement-action-' + ref + '"]',
    dismiss: '[data-ref="announcement-dismiss-' + ref + '"]'
  };

  this.cookieName = 'rkb_announcement_' + ref;
}

AnnouncementPopup.prototype.hide = function () {
  var announcement = document.querySelector(this.refs.announcement);
  if (!announcement.className.includes(this.cls.invisible)) {
    announcement.className = announcement.className
      .concat(' ' + this.cls.invisible);
  }
};

AnnouncementPopup.prototype.setCookie = function () {
  Cookies.set(this.cookieName, '1', { expires: 90 });
};

AnnouncementPopup.prototype.onClick = function (event) {
  var dismiss = utils.findTarget(this.refs.dismiss, event);
  if (dismiss) {
    event.preventDefault();
    this.hide();
    this.setCookie();
  }

  var action = utils.findTarget(this.refs.action, event);
  if (action) {
    event.preventDefault();
    this.hide();
    this.setCookie();
    location.assign(action.href);
  }
};

AnnouncementPopup.prototype.onBindEvents = function (event) {
  var announcement = utils.findTarget(this.refs.announcement, event);
  if (announcement) {
    if (Cookies.get(this.cookieName) === '1') {
      if (!announcement.className.includes(this.cls.invisible)) {
        announcement.className = announcement.className
          .concat(' ' + this.cls.invisible);
      }
    } else {
      announcement.className = announcement.className
        .replace(' ' + this.cls.invisible, '');
    }
  }
};

AnnouncementPopup.prototype.bindEvents = function () {
  this.onClick = this.onClick.bind(this);
  events.on(document, 'click', this.onClick);

  var announcement = document.querySelector(this.refs.announcement);
  this.onBindEvents = this.onBindEvents.bind(this);
  events.on(announcement, 'bindEvents', this.onBindEvents);
  events.emit(announcement, 'bindEvents');
};

module.exports = AnnouncementPopup;



//////////////////
// WEBPACK FOOTER
// ./_js/popups/announcement.js
// module id = 22
// module chunks = 3